import { PresenterAccountStatus } from '../../common/presenter-account-status';

export interface IPresenterTokenClaims {
    id: string;
    yearMonthCreated: string;
    displayName: string;
    fullName: string;
    email: string;
    accountStatus: PresenterAccountStatus;
    accountExpirationDate: number;
    tokenExpiration: number;
}


export class PresenterTokenClaims implements IPresenterTokenClaims {
    public id: string = '';
    public yearMonthCreated: string = '';
    public displayName: string = '';
    public fullName: string = '';
    public email: string = '';
    public accountStatus: PresenterAccountStatus = PresenterAccountStatus.Unknown;
    public accountExpirationDate: number = 0;
    public tokenExpiration: number = 0;
}


